import { render, staticRenderFns } from "./ToggleTheme.vue?vue&type=template&id=649a4277&scoped=true"
import script from "./ToggleTheme.vue?vue&type=script&lang=js"
export * from "./ToggleTheme.vue?vue&type=script&lang=js"
import style0 from "./ToggleTheme.vue?vue&type=style&index=0&id=649a4277&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.4_cssnano@5_9449f7de44cb275de9d2805a6df01d68/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a4277",
  null
  
)

export default component.exports